'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
  GenericLayout: 
  
    UI component that loads all the fields from contentful type "GenericLayout" 
    by leveraging the Product class.

    Fields in "GenericLayout" (04-2021): 
    media1, media2, media3, cta1, cta2, cta3, text1, text2, text3

    Note: field configs is key value pair of field names and the configs attached to it.
    
    this.genericLayoutConfig = {
      contentId: "2SgIirplZIVvGd5uesD2tY",
      contentSpace: "App",
      contentType: "genericLayout",
      fieldConfigs: {
        media1: {
          callback: (obj) => this._initAnimation(obj)
        },
        cta1: {
          callback: () => this._playAnimations()
        }
      }
    }
    
  Example use:

  this._$genericLayout.mogo().create('GenericLayout', this.genericLayoutConfig); 
*/
function GenericLayout() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this.preserveAspectRatio = false; // Used for animations
  this.presenter = $('[data-mogo-ui=Portal]').mogo().presenter;
  this.analytics = new Analytics();

  this.contentId = null;
  this.contentSpace = null;
  this.fieldConfigs = null;

  // Used for adding Alternate Content Id for AB testing
  this.ABTestEnabled = false;
  this.isControlVersion = null;
  this.contentIdAlternate = null;

  this._contentModelRef = null;
  this._contentModel = null;
  this.contentfulFieldItems = {};

  // Used as reference when the models are SET
  // when getModelProperty can be performed.
  this.contentfulPromise = $.Deferred();

  this.init = function () {
    // 'id' needed in case content id starts with a number
    this._contentModelRef = 'content.id_' + this.contentId;

    if (this.presenter.getModelProperty(this._contentModelRef)) {
      this._populateContent();
    } else {
      this._loadContent();
    }
  };

  this.initAllReady = function () {};

  this.destroy = function () {};

  this._loadContent = function () {
    var _this = this;

    this._contentful = new Contentful(_ContentfulConfiguration, $.extend({}, this._getContentfulSpaceParams(), { verboseLevel: 1 }));

    this._contentful.getResource('ENTRY', { entry_id: this.contentId }, function (data) {
      _this._storeContent(data);
      _this._populateContent();
    });
  };

  this._storeContent = function (data) {
    if (!this.presenter.models.content) {
      this.presenter.createModel('content', {
        data: {}
      });
    }
    this.presenter.setModelProperty(this._contentModelRef, data.items[0]);
    this.contentfulPromise.resolve();
  };

  this._populateContent = function () {
    var _this2 = this;

    // use Product class to do heavy lifting on content insertion
    // assumes specific HTML structure and content field names
    // TODO: make lower-level class that both Product and ActionPanel can use
    // content references without a specific attribute either insert descendant
    // HTML or populate existing HTML based on the type of content retrieved
    var nodeList = [].concat(_toConsumableArray(this.node.querySelectorAll('[data-content-ref]')));
    nodeList.forEach(function (node) {
      var contentRef = node.dataset.contentRef;

      var contentObject = _this2.presenter.getModelProperty(_this2._contentModelRef + '.' + contentRef);
      var contentfulItem = new Product(_this2._contentModelRef, _this2.presenter);
      var action = _this2._getNavigationAction(contentObject);
      var fieldConfigs = _this2._getFieldConfigs(_this2.fieldConfigs, contentRef);
      var fieldConfigsCallback = fieldConfigs.callback ? fieldConfigs.callback : false;

      if (contentRef === 'linkAction') {
        contentfulItem.setupLinkAction(node, 'nav-action-1');
      }
      // for string content, assume HTML content to be inserted as descendant
      if (typeof contentObject === 'string') {
        contentfulItem.loadHTML(node, contentRef);

        // for content that is a reference to an object (embedded content item)
      } else if ((typeof contentObject === 'undefined' ? 'undefined' : _typeof(contentObject)) === 'object') {
        var contentfulConfig = {};
        // Product assumes particular field names for specific content types
        if (contentObject._type === 'Asset' && contentRef.toLowerCase().includes('media')) {
          if (_this2.preserveAspectRatio && contentRef === 'media1') contentfulConfig.preserveAspectRatio = 'none';

          contentfulItem.loadMedia(node, contentfulConfig, contentRef, fieldConfigsCallback);
          // undo Product specific content
          node.childNodes[0].classList.remove('mUP-common__media-item', 'js--image');
        } else if (contentObject._contentType && contentObject._contentType.sys && contentObject._contentType.sys.id) {
          if (contentObject._contentType.sys.id === 'button' && contentRef.toLowerCase().includes('cta')) {
            contentfulItem.loadPrimaryCta(node, action, fieldConfigsCallback, {
              primaryCta: contentObject
            });
          }
        }
      }

      if (_this2.contentfulFieldItems[contentRef] === undefined) {
        contentfulItem.contentObject = contentObject; // augment contentful item with contentobject
        _this2.contentfulFieldItems[contentRef] = contentfulItem;
      }
    });

    // attribute values from external content values
    var attributesList = ['src', 'href'];
    attributesList.forEach(function (attributeName) {
      var attributeUpdateNodes = [].concat(_toConsumableArray(_this2.node.querySelectorAll('[data-content-attr-' + attributeName + ']')));
      attributeUpdateNodes.forEach(function (node) {
        var contentRef = node.dataset['contentAttr' + _this2._capitalizeFirstLetter(attributeName)];
        var contentObject = _this2.presenter.getModelProperty(_this2._contentModelRef + '.' + contentRef);

        // content must be a string
        if (typeof contentObject === 'string') {
          node.setAttribute(attributeName, contentObject);
        }
      });
    });
    $('#Portal').mogo().scanNodeForClickAnalytics(this.node);
    $(this.node).show();
  };

  /*
    _getNavigationAction: returns navigation action from contentfulobj otherwise null
  */
  this._getNavigationAction = function (contentfulObj) {
    var navAction = '';
    if (contentfulObj && contentfulObj.configuration) {
      navAction = contentfulObj.configuration.navigationActions[0].id;
    }

    return navAction;
  };

  /*
    _getFieldConfigs: returns configs for a field if present, otherwise false
  */
  this._getFieldConfigs = function (viewFieldConfigs, contentRefName) {
    var configs = false;
    if (viewFieldConfigs && viewFieldConfigs[contentRefName]) {
      configs = viewFieldConfigs[contentRefName];
    }
    return configs;
  };

  this._capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  this._getContentfulSpaceParams = function () {
    return this.contentSpace === 'App' ? ContentfulAppSpaceParams : ContentfulSpaceParams;
  };

  this.pushContentfulAnalyticsEvent = function () {
    this._contentModel = this.presenter.getModelProperty(this._contentModelRef);

    this.analytics.forcePushEvent('contentful', {
      type: [this._contentModel._contentType.sys.id],
      category: [this._contentModel.category],
      content: [this._contentModel._id],
      version: [this._contentModel._updatedAt]
    });
  };
}